// Modules
import styled from "styled-components"
import colors from "~constants/colors"

export const CoveredImage = styled.img`
  height: 100%;
  object-fit: cover;
  width: 100%;
`

export const ImagePreview = styled.img`
  height: 100%;
  margin: 0;
  object-fit: contain;

  &.cover {
    object-fit: cover;
    width: 100%;
  }

  &.multiple {
    object-fit: scale-down;
  }
`

export const ImageUploadContainer = styled.div`
  min-width: 200px;
  text-align: center;
  width: 100%;
  justify-items: center;
  display: flex;
  flex-direction: column;
`

export const ImagePreviewContainer = styled.div`
  border: 1px dashed rgba(0, 0, 0, 0.85);
  border-radius: 12px;
  min-height: 150px;
  margin-bottom: 15px;
  padding: 15px;
  position: relative;
  overflow: auto;
  height: 150px;

  &.logo {
    align-content: center;
    border-radius: 200px;
    height: 150px;
    width: 150px;
    align-self: center;
  }

  &.multiple {
    display: flex;
    justify-content: center;
  }

  &.cover {
    height: 130px;
  }
`

export const ImagePreviewItem = styled.div`
  position: relative;
  background-color: ${colors.white};
  justify-content: center;
  display: flex;

  &:not(:last-child) {
    margin-right: 10px;
  }

  &.multiple {
    width: 300px;
    height: 300px;
  }
`

export const InfoLegend = styled.div`
  font-size: 12px;
  margin-top: 5px;
`

export const ErrorsContainer = styled.ul`
  color: ${colors.red};
  font-size: 13px;
  font-weight: 500;
  list-style-type: none;
  margin: 10px 0 0 0;
  padding: 0;

  > li {
    line-height: 100%;
    margin: 0;

    &:not(:last-child) {
      margin-bottom: 5px;
    }
  }
`

export const NoImageContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  font-size: small;

  > svg {
    color: ${colors.cerulean};
    font-size: 40px;
  }

  &.logo {
    height: 100%;
  }
`

export const RemoveImageButtonContainer = styled.div`
  background-color: ${colors.red3};
  border-radius: 20px;
  position: absolute;
  right: 2px;
  top: 2px;
  z-index: 1;
`
